import { debug } from '../../../utils';
import { parseIcyMetadata } from './icy';
import { parseId3Metadata } from './id3';
export function isValidMetadata(metadata, previousMetadata) {
    const { title, subtitle, isAdBreak, usePrimaryMetadata, startMs } = metadata || {};
    const { title: previousTitle, subtitle: previousSubtitle, usePrimaryMetadata: previousUsePrimaryMetadata, } = previousMetadata || {};
    // If there is no metadata, it failed parsing
    if (!metadata) {
        // debug logs for this case are already handled in parsing functions
        return false;
    }
    // Ad breaks are always valid
    if (isAdBreak) {
        return true;
    }
    // If usePrimaryMetadata is true, it is valid if it was not previously true (don't need to re-emit primary)
    if (usePrimaryMetadata) {
        if (!previousUsePrimaryMetadata) {
            debug('Using primary metadata at position', startMs);
        }
        return !previousUsePrimaryMetadata;
    }
    // Title and subtitle are required
    if (!(title?.length && subtitle?.length)) {
        debug('Invalid metadata: missing title and/or subtitle', metadata);
        return false;
    }
    // Otherwise, if the title and subtitle have changed, the metadata is valid
    const isNewMetadata = !(title === previousTitle && subtitle === previousSubtitle);
    if (!isNewMetadata) {
        debug.verbose('Skipping metadata update: no change');
    }
    return isNewMetadata;
}
export function parseMetadata(metadata, setIcyDelay = false) {
    if (metadata.icy) {
        return parseIcyMetadata(metadata.icy, setIcyDelay);
    }
    if (metadata.id3) {
        return parseId3Metadata(metadata);
    }
}
